import React from "react";
import {Alert, Card, IconButton} from "@mui/material";
import {Typography} from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import Divider from "@mui/material/Divider";
import CardText from "./cardComponents/cardText";
import CardDivider from "./cardComponents/cardDivider";
import CardLinearProgress from "./cardComponents/cardLinearProgress";
import CompletedScoreObject from "./cardComponents/completedScoreObjects";
import LivePlayIcon from "./cardComponents/livePlayIcon";
import StatusText from "./cardComponents/statusText";
import PickleballServerIndicator from "./cardComponents/pickleballServerIndicator";
import {
    MatchStatus,
    UmpireMode,
    ServerTracking,
    calculatePickleballServerNumber,
} from "../utils/matchConstants";

type Players = {
    // [key: string]: {
    //   team1: string;
    //   team2: string;
    // };
    team1: string;
    team2: string;
};
type Score = {
    duration: any;
    serveEvent: any;
    team1: {
        gameScore: any;
        isCurrentServer: boolean;
        isWinner: boolean;
        sets: any;
        scorePosition?: number;      // Team's current score (for pickleball)
        serverNumber1?: number;       // Player designated as server #1
        servingPlayer?: number;       // Current serving player number
    };
    team2: {
        gameScore: any;
        isCurrentServer: any;
        isWinner: boolean;
        sets: any;
        scorePosition?: number;      // Team's current score (for pickleball)
        serverNumber1?: number;       // Player designated as server #1
        servingPlayer?: number;       // Current serving player number
    };
    timeZone?: any;
    serverNumber?: number;           // The third number in pickleball (1 or 2)
    servingPlayer?: number;          // Which team is serving (1 or 2)
    umpireMode?: number;             // Umpire mode constant
    matchStatus?: number;            // Match status constant
};
type ScoreCardProps = {
    matchId?: any;
    // players: Players;
    matchDescription?: string;
    ScoreCardId?: any;
    matchTypeName: string | null;
    HeadingId?: any;
    // duration: string;
    // serveEvent: string;
    date?: string;
    score?: Score;
    status: string;
    //duration?: any;
    players?: Players;
    isAlertOpen: boolean;
    handleShare: (event: any) => void;
};

export default function ScoreCard(props: ScoreCardProps) {
    console.log("status inside the card", props.status);

    // Determine if this is pickleball doubles with server number tracking
    const isPickleballMode = props.score?.umpireMode === UmpireMode.UMPIRE_MODE_PICKLEBALL;
    const isDoublesMatch =
        props.matchTypeName?.toLowerCase() === "doubles" ||
        (props.players?.team1?.includes("/") && props.players?.team2?.includes("/"));
    const showPickleballServerNumber = isPickleballMode && isDoublesMatch && props.score?.serverNumber;

    // Get the server number for display (1 or 2, or 0 if not applicable)
    const serverNumber = props.score?.serverNumber || 0;

    return (
        <>
            {(props.status.toLowerCase() === "in progress" ||
                props.status.toLowerCase() === "scheduled" ||
                props.status.toLowerCase() === "completed" ||
                props.status.toLowerCase() === "suspended" ||
                props.status.toLowerCase() === "default" ||
                props.status.toLowerCase() === "interrupted" ||
                props.status.toLowerCase() === "locked" ||
                props.status.toLowerCase() === "retired" ||
                props.status.toLowerCase() === "walkover" ||
                props.status.toLowerCase() === "scorecard") && ( //checking the status
                <div
                    id={"match_" + props.matchId + "_score_div"}
                    className="mb-4 mx-1 "
                    key={props.matchId}
                >
                    <Card
                        className=" h-150 md:max-h-160 md:max-w-260 px-1 py-1 my-9  border-solid border-1 rounded-none "
                        style={styles.container}
                    >
                        <div>
                            <div
                                id={"match_" + props.matchId + "_score_div_heading"}
                                className="justify-between px-0 py-0 mb-1 "
                                style={styles.typoStyle}
                            >
                                <CardText
                                    // matchTypeName={props.matchTypeName}
                                    matchDescription={props.matchDescription}
                                    // status={props.status}
                                    //date={props.date}
                                    classname={"w-4/7"}
                                    textColor={"text.primary"}
                                    variant="body2"
                                />
                                {props.status !== undefined && (
                                    <>
                                        {(props.status.toLowerCase() === "completed" || props.status.toLowerCase() === "default" || props.status.toLowerCase() === "retired" || props.status.toLowerCase() === "walkover") ? (
                                            <StatusText
                                                status={props.status}
                                                classname={"w-2/7"}
                                                textColor={"#007bff"}
                                                fontWeight={"bold"}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </>
                                )}
                                {props.status !== undefined && (
                                    <>
                                        {(props.status.toLowerCase() === "in progress" || props.status.toLowerCase() === "scorecard") && (
                                            <StatusText
                                                status="Live" //set value as Live
                                                classname={"w-2/7"}
                                                textColor={"green"}
                                                fontWeight={"bold"}
                                            />
                                        )}
                                    </>
                                )}
                                {props.status !== undefined && (
                                    <>
                                        {(props.status.toLowerCase() === "scheduled" || props.status.toLowerCase() === "locked") && (
                                            <StatusText
                                                status={props.status}
                                                classname={"w-2/7"}
                                                textColor={"black"}
                                                fontWeight={"bold"}
                                            />
                                        )}
                                    </>
                                )}
                                {props.status !== undefined && (
                                    <>
                                        {(props.status.toLowerCase() === "suspended" || props.status.toLowerCase() === "interrupted") && (
                                            <StatusText
                                                //matchTypeName={props.matchTypeName}
                                                //matchDescription={props.matchDescription}
                                                status={props.status}
                                                //date={undefined}
                                                classname={"w-2/7"}
                                                textColor={"#ed058c"}
                                                fontWeight={"bold"}
                                            />
                                        )}
                                    </>
                                )}
                            </div>
                            {props.status !== undefined && (
                                <>
                                    {(props.status.toLowerCase() === "completed" || props.status.toLowerCase() === "default" || props.status.toLowerCase() === "retired" || props.status.toLowerCase() === "walkover") && (
                                        <CardDivider
                                            height={"1px"}
                                            background={"#007bff"}
                                            marginBottom={"2px"}
                                        />
                                    )}
                                </>
                            )}
                            {props.status !== undefined && (
                                <>
                                    {(props.status.toLowerCase() === "in progress" || props.status.toLowerCase() === "scorecard") && (
                                        <CardLinearProgress
                                            color="success"
                                            variants="indeterminate"
                                            height="1px"
                                            marginBottom="2px"
                                        />
                                    )}
                                </>
                            )}
                            {props.status !== undefined && (
                                <>
                                    {(props.status.toLowerCase() === "scheduled" || props.status.toLowerCase() === "locked") && (
                                        <CardDivider
                                            height={"1px"}
                                            background={"green"}
                                            marginBottom={"2px"}
                                        />
                                    )}
                                </>
                            )}
                            {props.status !== undefined && (
                                <>
                                    {(props.status.toLowerCase() === "suspended" || props.status.toLowerCase() === "interrupted") && (
                                        <CardDivider
                                            height={"1px"}
                                            background={"#ed058c"}
                                            marginBottom={"2px"}
                                        />
                                    )}
                                </>
                            )}

                            <>

                                {(props.matchTypeName === null ||
                                    props.matchTypeName?.toLowerCase() === "doubles") &&
                                props.players &&
                                props.players.team1?.includes("/") &&
                                props.players.team2?.includes("/") ? (
                                    <div>
                                        <div className="px-0 py-0 mt-1 mb-1">
                                            <div
                                                className="flex flex-row justify-between"
                                                style={styles.namesTypo}
                                            >
                                                <div className="flex flex-col">
                                                    <div className="w-full flex flex-row">
                                                        <div
                                                            id={
                                                                "match_" +
                                                                props.matchId +
                                                                "_doubles_team1_players"
                                                            }
                                                            className="ml-0"
                                                        >
                                                            {props.players !== undefined && (
                                                                <CardText
                                                                    variant="body1"
                                                                    textColor="text.primary"
                                                                    players={props.players.team1
                                                                        .split(/(?:\s*\/\s*|\s*\/\s*\s*)/)

                                                                        .map((player, index) => (
                                                                            <div
                                                                                key={index}
                                                                                style={{
                                                                                    fontWeight: props.score?.team1
                                                                                        .isWinner
                                                                                        ? "bold"
                                                                                        : "normal",
                                                                                }}
                                                                            >
                                                                                {player}
                                                                            </div>
                                                                        ))}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {props.status.toLowerCase() !== "scheduled" &&
                                                props.status.toLowerCase() !== "in progress" &&
                                                props.status.toLowerCase() !== "suspended" &&
                                                props.status.toLowerCase() !== "interrupted" ? (
                                                    <div
                                                        className="px-0 mx-0 mt-2"
                                                        style={styles.namesTypo}
                                                    >
                                                        {/* doubles team1 score complete */}
                                                        <Typography
                                                            style={{
                                                                ...styles.namesTypo.scoreOutStyle.score,

                                                                fontWeight: props.score?.team1.isWinner
                                                                    ? "bold"
                                                                    : "normal",
                                                            }}
                                                        >
                                                            {props.score?.team1?.sets?.map(
                                                                (set: any, index: any) => (
                                                                    <span
                                                                        key={index}
                                                                        style={
                                                                            styles.namesTypo.scoreOutStyle.score
                                                                                .completed
                                                                        }
                                                                    >
                                    {set.setScore}
                                                                        {set.tieBreakScore && (
                                                                            <sup style={styles.supTiebreak}>
                                                                                {set.tieBreakScore}
                                                                            </sup>
                                                                        )}
                                                                        {index !==
                                                                            props.score?.team1.sets.length - 1 &&
                                                                            "    "}
                                  </span>
                                                                )
                                                            )}
                                                        </Typography>
                                                    </div>
                                                ) : (props.status.toLowerCase() === "in progress" || props.status.toLowerCase() === "scorecard") ? (
                                                    <div className="mt-2" style={styles.namesTypo}>
                                                        {props.score?.team1.isCurrentServer === true ? (
                                                            <div className="flex flex-row px-0">
                                                                {showPickleballServerNumber ? (
                                                                    <PickleballServerIndicator serverNumber={serverNumber} />
                                                                ) : (
                                                                    <LivePlayIcon/>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}

                                                        <div className="flex flex-row pl-0 ml-0 ">
                                                            {/* Score goes here live double*/}
                                                            <Typography
                                                                style={{
                                                                    ...styles.namesTypo.scoreOutStyle.score,
                                                                    fontWeight: props.score?.team1.isWinner
                                                                        ? "bold"
                                                                        : "normal",
                                                                }}
                                                            >
                                                                {props.score?.team1?.sets?.map(
                                                                    (set: any, index: any) => (
                                                                        <span
                                                                            key={index}
                                                                            style={
                                                                                styles.namesTypo.scoreOutStyle.score
                                                                            }
                                                                        >
                                      {set.setScore}
                                                                            {set.tieBreakScore && (
                                                                                <sup style={styles.supTiebreak}>
                                                                                    {set.tieBreakScore}
                                                                                </sup>
                                                                            )}
                                                                            {index !==
                                                                                props.score?.team1.sets.length - 1 &&
                                                                                "    "}
                                    </span>
                                                                    )
                                                                )}
                                                            </Typography>
                                                            {props.score?.team1.gameScore && (
                                                                <Typography
                                                                    className="outline outline-offset-0 outline-1 h-4 outline-[#04bd19]"
                                                                    style={
                                                                        styles.namesTypo.scoreOutStyle.scoreLive
                                                                    }
                                                                >
                                                                    {props.score.team1.gameScore}
                                                                </Typography>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (props.status.toLowerCase() === "suspended" || props.status.toLowerCase() === "interrupted") ? (
                                                    <div className="mt-2" style={styles.namesTypo}>
                                                        {props.score?.team1?.isCurrentServer === true ? (
                                                            <div className="flex flex-row px-0 py-0 ">
                                                                <LivePlayIcon/>
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}

                                                        <div className="flex flex-row pl-0 ml-0 ">
                                                            {/* Score goes here sus */}
                                                            <Typography
                                                                style={{
                                                                    ...styles.namesTypo.scoreOutStyle.score,
                                                                    fontWeight: props.score?.team1.isWinner
                                                                        ? "bold"
                                                                        : "normal",
                                                                }}
                                                            >
                                                                {props.score?.team1?.sets?.map(
                                                                    (set: any, index: any) => (
                                                                        <span
                                                                            key={index}
                                                                            style={
                                                                                styles.namesTypo.scoreOutStyle.score
                                                                            }
                                                                        >
                                      {set.setScore}
                                                                            {set.tieBreakScore && (
                                                                                <sup style={styles.supTiebreak}>
                                                                                    {set.tieBreakScore}
                                                                                </sup>
                                                                            )}
                                                                            {index !==
                                                                                props.score?.team1.sets.length - 1 &&
                                                                                "    "}
                                    </span>
                                                                    )
                                                                )}
                                                            </Typography>
                                                            {props.score?.team1.gameScore && (
                                                                <Typography
                                                                    className="outline outline-offset-0 outline-1 h-4 outline-[#04bd19]"
                                                                    style={
                                                                        styles.namesTypo.scoreOutStyle.scoreLive
                                                                    }
                                                                >
                                                                    {props.score.team1.gameScore}
                                                                </Typography>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    (props.status.toLowerCase() === "scheduled" || props.status.toLowerCase() === "locked") && (
                                                        <div className="flex flex-col">
                                                            <div className="w-full flex flex-row">
                                                                <div
                                                                    id={
                                                                        "match_" +
                                                                        props.matchId +
                                                                        "_doubles_team1_players"
                                                                    }
                                                                    className="ml-0"
                                                                >
                                                                    <></>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                        <Divider/>
                                        <div className="px-0 py-0 mt-1">
                                            <div
                                                className="flex flex-row justify-between"
                                                style={styles.namesTypo}
                                            >
                                                <div className="flex flex-col">
                                                    <div
                                                        className="w-full flex flex-row"
                                                        style={{marginTop: "-2px"}}
                                                    >
                                                        <div
                                                            id={
                                                                "match_" +
                                                                props.matchId +
                                                                "_doubles_team2_players"
                                                            }
                                                            className="ml-0"
                                                        >
                                                            {props.players !== undefined && (
                                                                <CardText
                                                                    variant={"body1"}
                                                                    textColor={"text.primary"}
                                                                    // pno={props.players[3].pno}
                                                                    players={props.players.team2
                                                                        .split(/(?:\s*\/\s*|\s*\/\s*\s*)/)

                                                                        .map((player, index) => (
                                                                            <div
                                                                                key={index}
                                                                                style={{
                                                                                    fontWeight: props.score?.team2
                                                                                        .isWinner
                                                                                        ? "bold"
                                                                                        : "normal",
                                                                                }}
                                                                            >
                                                                                {player}
                                                                            </div>
                                                                        ))}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                {props.status.toLowerCase() !== "scheduled" &&
                                                props.status.toLowerCase() !== "in progress" &&
                                                props.status.toLowerCase() !== "suspended" &&
                                                props.status.toLowerCase() !== "interrupted" ? (
                                                    <div className="mt-2" style={styles.namesTypo}>
                                                        {/* Score goes here completed */}
                                                        <Typography
                                                            style={{
                                                                ...styles.namesTypo.scoreOutStyle.score,

                                                                fontWeight: props.score?.team2.isWinner
                                                                    ? "bold"
                                                                    : "normal",
                                                            }}
                                                        >
                                                            {props.score?.team2?.sets?.map(
                                                                (set: any, index: any) => (
                                                                    <span
                                                                        key={index}
                                                                        style={
                                                                            styles.namesTypo.scoreOutStyle.score
                                                                                .completed
                                                                        }
                                                                    >
                                    {set.setScore}
                                                                        {set.tieBreakScore && (
                                                                            <sup style={styles.supTiebreak}>
                                                                                {set.tieBreakScore}
                                                                            </sup>
                                                                        )}
                                                                        {index !==
                                                                            props.score?.team2.sets.length - 1 &&
                                                                            "    "}
                                  </span>
                                                                )
                                                            )}
                                                        </Typography>
                                                    </div>
                                                ) : (props.status.toLowerCase() === "in progress" || props.status.toLowerCase() === "scorecard") ? (
                                                    <div className="mt-2" style={styles.namesTypo}>
                                                        {props.score?.team2.isCurrentServer === true ? (
                                                            <div className="flex flex-row px-0">
                                                                <LivePlayIcon/>
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}

                                                        <div className="flex flex-row pl-0 ml-0 ">
                                                            {/* Score goes here live double*/}
                                                            <Typography
                                                                style={{
                                                                    ...styles.namesTypo.scoreOutStyle.score,
                                                                    fontWeight: props.score?.team2.isWinner
                                                                        ? "bold"
                                                                        : "normal",
                                                                }}
                                                            >
                                                                {props.score?.team2?.sets?.map(
                                                                    (set: any, index: any) => (
                                                                        <span
                                                                            key={index}
                                                                            style={
                                                                                styles.namesTypo.scoreOutStyle.score
                                                                            }
                                                                        >
                                      {set.setScore}
                                                                            {set.tieBreakScore && (
                                                                                <sup style={styles.supTiebreak}>
                                                                                    {set.tieBreakScore}
                                                                                </sup>
                                                                            )}
                                                                            {index !==
                                                                                props.score?.team2.sets.length - 1 &&
                                                                                "    "}
                                    </span>
                                                                    )
                                                                )}
                                                            </Typography>
                                                            {props.score?.team2.gameScore && (
                                                                <Typography
                                                                    className="outline outline-offset-0 outline-1 h-4 outline-[#04bd19]"
                                                                    style={
                                                                        styles.namesTypo.scoreOutStyle.scoreLive
                                                                    }
                                                                >
                                                                    {props.score.team2.gameScore}
                                                                </Typography>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (props.status.toLowerCase() === "suspended" || props.status.toLowerCase() === "interrupted") ? (
                                                    <div className="mt-2" style={styles.namesTypo}>
                                                        {props.score?.team2.isCurrentServer === true ? (
                                                            <div className="flex flex-row px-0 py-0 ">
                                                                <LivePlayIcon/>
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}

                                                        <div className="flex flex-row pl-0 ml-0 ">
                                                            {/* Score goes here sus */}
                                                            <Typography
                                                                style={{
                                                                    ...styles.namesTypo.scoreOutStyle.score,
                                                                    fontWeight: props.score?.team2.isWinner
                                                                        ? "bold"
                                                                        : "normal",
                                                                }}
                                                            >
                                                                {props.score?.team2?.sets?.map(
                                                                    (set: any, index: any) => (
                                                                        <span
                                                                            key={index}
                                                                            style={
                                                                                styles.namesTypo.scoreOutStyle.score
                                                                            }
                                                                        >
                                      {set.setScore}
                                                                            {set.tieBreakScore && (
                                                                                <sup style={styles.supTiebreak}>
                                                                                    {set.tieBreakScore}
                                                                                </sup>
                                                                            )}
                                                                            {index !==
                                                                                props.score?.team2.sets.length - 1 &&
                                                                                "    "}
                                    </span>
                                                                    )
                                                                )}
                                                            </Typography>
                                                            {props.score?.team2.gameScore && (
                                                                <Typography
                                                                    className="outline outline-offset-0 outline-1 h-4 outline-[#04bd19]"
                                                                    style={
                                                                        styles.namesTypo.scoreOutStyle.scoreLive
                                                                    }
                                                                >
                                                                    {props.score.team2.gameScore}
                                                                </Typography>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    (props.status.toLowerCase() === "scheduled" || props.status.toLowerCase() === "locked") && (
                                                        <div className="flex flex-col">
                                                            <div className="w-full flex flex-row">
                                                                <div className="ml-1">
                                                                    <></>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                            {/* </CardContent> */}
                                        </div>
                                    </div>
                                ) : (
                                    // =====================end doubles div=========================================================

                                    <div>
                                        <div className="px-0 py-0 mt-3 mb-3">
                                            <div
                                                className="flex flex-row justify-between"
                                                style={styles.namesTypo}
                                            >
                                                <div className="flex flex-col">
                                                    <div className="w-full flex flex-row ">
                                                        <div className="flex md:items-start ">
                                                            <div
                                                                id={
                                                                    "match_" +
                                                                    props.matchId +
                                                                    "_singles_team1_player"
                                                                }
                                                                className="ml-0 "
                                                            >
                                                                {props.players !== undefined ? (
                                                                    <CardText
                                                                        variant={"body1"}
                                                                        textColor={"text.primary"}
                                                                        // pno={props.pno}
                                                                        players={props.players.team1}
                                                                        style={{
                                                                            fontWeight: props.score?.team1.isWinner
                                                                                ? "bold"
                                                                                : "normal",
                                                                            fontColor: "red"

                                                                        }}
                                                                    />
                                                                ) : (
                                                                    "undefined"
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <Divider/>
                                                {props.status.toLowerCase() !== "scheduled" &&
                                                props.status.toLowerCase() !== "in progress" &&
                                                props.status.toLowerCase() !== "suspended" &&
                                                props.status.toLowerCase() !== "interrupted" ? (
                                                    <div className="px-0 mx-0" style={styles.namesTypo}>
                                                        {/* set scores completed */}
                                                        <Typography
                                                            style={{
                                                                ...styles.namesTypo.scoreOutStyle.score,

                                                                fontWeight: props.score?.team1.isWinner
                                                                    ? "bold"
                                                                    : "normal",
                                                            }}
                                                        >
                                                            {props.score?.team1?.sets?.map(
                                                                (set: any, index: any) => (
                                                                    <span
                                                                        key={index}
                                                                        style={
                                                                            styles.namesTypo.scoreOutStyle.score
                                                                                .completed
                                                                        }
                                                                    >
                                    {set.setScore}
                                                                        {set.tieBreakScore && (
                                                                            <sup style={styles.supTiebreak}>
                                                                                {set.tieBreakScore}
                                                                            </sup>
                                                                        )}
                                                                        {index !==
                                                                            props.score?.team1.sets.length - 1 &&
                                                                            "    "}
                                  </span>
                                                                )
                                                            )}
                                                        </Typography>
                                                    </div>
                                                ) : (props.status.toLowerCase() === "in progress" || props.status.toLowerCase() === "scorecard") ? (
                                                    <div className="mt-0" style={styles.namesTypo}>
                                                        {props.score?.team1.isCurrentServer === true ? (
                                                            <div className="flex flex-row px-0">
                                                                <LivePlayIcon/>
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}

                                                        <div className="flex flex-row pl-0 ml-0 ">
                                                            {/* Score goes here */}
                                                            <Typography
                                                                style={{
                                                                    ...styles.namesTypo.scoreOutStyle.score,
                                                                    fontWeight: props.score?.team1.isWinner
                                                                        ? "bold"
                                                                        : "normal",
                                                                }}
                                                            >
                                                                {props.score?.team1?.sets?.map(
                                                                    (set: any, index: any) => (
                                                                        <span
                                                                            key={index}
                                                                            style={
                                                                                styles.namesTypo.scoreOutStyle.score
                                                                            }
                                                                        >
                                      {set.setScore}
                                                                            {set.tieBreakScore && (
                                                                                <sup style={styles.supTiebreak}>
                                                                                    {set.tieBreakScore}
                                                                                </sup>
                                                                            )}
                                                                            {index !==
                                                                                props.score?.team1.sets.length - 1 &&
                                                                                "    "}
                                    </span>
                                                                    )
                                                                )}
                                                            </Typography>
                                                            {props.score?.team1.gameScore && (
                                                                <Typography
                                                                    className="outline outline-offset-0 outline-1 h-4 outline-[#04bd19]"
                                                                    style={
                                                                        styles.namesTypo.scoreOutStyle.scoreLive
                                                                    }
                                                                >
                                                                    {props.score.team1.gameScore}
                                                                </Typography>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (props.status.toLowerCase() === "suspended" || props.status.toLowerCase() === "interrupted") ? (
                                                    <div className="mt-0" style={styles.namesTypo}>
                                                        {props.score?.team1.isCurrentServer === true ? (
                                                            <div className="flex flex-row px-0 py-0 ">
                                                                <LivePlayIcon/>
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}

                                                        <div className="flex flex-row pl-0 ml-0 ">
                                                            {/* Score live goes here */}
                                                            <Typography
                                                                style={{
                                                                    ...styles.namesTypo.scoreOutStyle.score,
                                                                    fontWeight: props.score?.team1.isWinner
                                                                        ? "bold"
                                                                        : "normal",
                                                                }}
                                                            >
                                                                {props.score?.team1?.sets?.map(
                                                                    (set: any, index: any) => (
                                                                        <span
                                                                            key={index}
                                                                            style={
                                                                                styles.namesTypo.scoreOutStyle.score
                                                                            }
                                                                        >
                                      {set.setScore}
                                                                            {set.tieBreakScore && (
                                                                                <sup style={styles.supTiebreak}>
                                                                                    {set.tieBreakScore}
                                                                                </sup>
                                                                            )}
                                                                            {index !==
                                                                                props.score?.team1.sets.length - 1 &&
                                                                                "    "}
                                    </span>
                                                                    )
                                                                )}
                                                            </Typography>
                                                            {props.score?.team1.gameScore && (
                                                                <Typography
                                                                    className="outline outline-offset-0 outline-1 h-4 outline-[#04bd19]"
                                                                    style={
                                                                        styles.namesTypo.scoreOutStyle.scoreLive
                                                                    }
                                                                >
                                                                    {props.score.team1.gameScore}
                                                                </Typography>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    (props.status.toLowerCase() === "scheduled" || props.status.toLowerCase() === "locked") && (
                                                        <div className="flex flex-col">
                                                            <div className="w-full flex flex-row">
                                                                <div className="ml-1">
                                                                    <></>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                        <Divider
                                            style={{marginBottom: "4px", marginTop: "2px"}}
                                        />
                                        <div className="px-0 py-0 mt-3 mb-2">
                                            <div
                                                className="flex flex-row justify-between"
                                                style={styles.namesTypo}
                                            >
                                                <div className="flex flex-col">
                                                    <div className="w-full flex flex-row">
                                                        <div
                                                            id={
                                                                "match_" +
                                                                props.matchId +
                                                                "_singles_team2_player"
                                                            }
                                                            className="ml-0"
                                                        >
                                                            {props.players !== undefined ? (
                                                                <CardText
                                                                    variant={"body1"}
                                                                    textColor={"text.primary"}
                                                                    // pno={props.pno}
                                                                    players={props.players.team2}
                                                                    style={{
                                                                        fontWeight: props.score?.team2.isWinner
                                                                            ? "bold"
                                                                            : "normal",
                                                                    }}
                                                                />
                                                            ) : (
                                                                "undefined"
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                {props.status.toLowerCase() !== "scheduled" &&
                                                props.status.toLowerCase() !== "in progress" &&
                                                props.status.toLowerCase() !== "suspended" &&
                                                props.status.toLowerCase() !== "interrupted" ? (
                                                    <div style={styles.namesTypo}>
                                                        {/* Score goes here */}
                                                        {/* set scores completed*/}

                                                        <Typography
                                                            style={{
                                                                ...styles.namesTypo.scoreOutStyle.score,

                                                                fontWeight: props.score?.team2.isWinner
                                                                    ? "bold"
                                                                    : "normal",
                                                            }}
                                                        >
                                                            {props.score?.team2?.sets?.map(
                                                                (set: any, index: any) => (
                                                                    <span
                                                                        key={index}
                                                                        style={
                                                                            styles.namesTypo.scoreOutStyle.score
                                                                                .completed
                                                                        }
                                                                    >
                                    {set.setScore}
                                                                        {set.tieBreakScore && (
                                                                            <sup style={styles.supTiebreak}>
                                                                                {set.tieBreakScore}
                                                                            </sup>
                                                                        )}
                                                                        {index !==
                                                                            props.score?.team2.sets.length - 1 && " "}
                                  </span>
                                                                )
                                                            )}
                                                        </Typography>
                                                        {/* game score */}
                                                    </div>
                                                ) : (props.status.toLowerCase() === "in progress" || props.status.toLowerCase() === "scorecard") ? (
                                                    <div className="mt-0" style={styles.namesTypo}>
                                                        {props.score?.team2.isCurrentServer === true ? (
                                                            <div className="flex flex-row px-0 py-0 ">
                                                                <LivePlayIcon/>
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                        <div className="flex flex-row pl-0 ml-0">
                                                            {/* Score goes here live */}
                                                            <Typography
                                                                style={{
                                                                    ...styles.namesTypo.scoreOutStyle.score,
                                                                    fontWeight: props.score?.team2.isWinner
                                                                        ? "bold"
                                                                        : "normal",
                                                                }}
                                                            >
                                                                {props.score?.team2?.sets?.map(
                                                                    (set: any, index: any) => (
                                                                        <span
                                                                            key={index}
                                                                            style={
                                                                                styles.namesTypo.scoreOutStyle.score
                                                                            }
                                                                        >
                                      {set.setScore}
                                                                            {set.tieBreakScore && (
                                                                                <sup style={styles.supTiebreak}>
                                                                                    {set.tieBreakScore}
                                                                                </sup>
                                                                            )}
                                                                            {index !==
                                                                                props.score?.team2.sets.length - 1 &&
                                                                                "    "}
                                    </span>
                                                                    )
                                                                )}
                                                            </Typography>
                                                            {props.score?.team2.gameScore && (
                                                                <Typography
                                                                    className="outline outline-offset-0 outline-1 h-4 outline-[#04bd19]"
                                                                    style={
                                                                        styles.namesTypo.scoreOutStyle.scoreLive
                                                                    }
                                                                >
                                                                    {props.score.team2.gameScore}
                                                                </Typography>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (props.status.toLowerCase() === "suspended" || props.status.toLowerCase() === "interrupted") ? (
                                                    <div className="mt-0" style={styles.namesTypo}>
                                                        {props.score?.team2.isCurrentServer === true ? (
                                                            <div className="flex flex-row px-0 py-0 ">
                                                                <LivePlayIcon/>
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                        <div className="flex flex-row pl-0 ml-0">
                                                            {/* Score goes here sus*/}
                                                            <Typography
                                                                style={{
                                                                    ...styles.namesTypo.scoreOutStyle.score,
                                                                    fontWeight: props.score?.team2.isWinner
                                                                        ? "bold"
                                                                        : "normal",
                                                                }}
                                                            >
                                                                {props.score?.team2?.sets?.map(
                                                                    (set: any, index: any) => (
                                                                        <span
                                                                            key={index}
                                                                            style={
                                                                                styles.namesTypo.scoreOutStyle.score
                                                                            }
                                                                        >
                                      {set.setScore}
                                                                            {set.tieBreakScore && (
                                                                                <sup style={styles.supTiebreak}>
                                                                                    {set.tieBreakScore}
                                                                                </sup>
                                                                            )}
                                                                            {index !==
                                                                                props.score?.team2.sets.length - 1 &&
                                                                                "    "}
                                    </span>
                                                                    )
                                                                )}
                                                            </Typography>
                                                            {props.score?.team2.gameScore && (
                                                                <Typography
                                                                    className="outline outline-offset-0 outline-1 h-4 outline-[#04bd19]"
                                                                    style={
                                                                        styles.namesTypo.scoreOutStyle.scoreLive
                                                                    }
                                                                >
                                                                    {props.score.team2.gameScore}
                                                                </Typography>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        </div>
                        <Divider style={{marginTop: "4px"}}/>
                        <div
                            id={"match_" + props.matchId + "__footer"}
                            className=" h-5 md:h-5 mx-0 my-0 py-0 px-0"
                            style={styles.venueStyle}
                        >
                            <Typography
                                className="w-2/7 pt-1 md:pt-1"
                                variant="body1"
                                color="text.primary"
                                style={styles.venueStyle.venueFontSize}
                            >
                                {props.score?.duration && (
                                    <>
                                        Duration: {` ${props.score.duration} `}
                                    </>
                                )}

                            </Typography>
                            <div className=" justify-between flex flex-row ml-7 sm:px-0">
                                {(props.status.toLowerCase() === "in progress" && (props.score?.serveEvent !== null && props.score?.serveEvent)) ? (
                                    <div>
                                        <Typography
                                            className="w-2/7 lg:pl-10 pt-1 md:pt-1"
                                            variant="body1"
                                            color="text.primary"
                                            style={styles.venueStyle.venueFontSize}
                                        >
                                            Serve Event:{" "}
                                            {typeof props.score.serveEvent === "string"
                                                ? props.score.serveEvent
                                                : props.score.serveEvent?.events?.[0]?.event || ""}
                                        </Typography>
                                    </div>
                                ) : (
                                    ""
                                )}
                                <IconButton
                                    className=" w-3/7 pt-0 "
                                    aria-label="share"
                                    onClick={props.handleShare}
                                >
                                    <ShareIcon style={{width: 15}}/>

                                </IconButton>
                            </div>
                        </div>
                    </Card>
                </div>
            )}
        </>
    );
}

const styles = {
    container: {
        borderStyle: "ridge",
        width: "100%",
        margin: "auto",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",

        alignItems: "left",
        fontWeight: "bold",
    },
    typoStyle: {
        paddingLeft: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: 0,
        display: "flex",
        flexDirection: "row",

        matchType: {
            fontSize: 12,
        },
        matchTitle: {
            fontSize: 12,
        },
        matchStatus: {
            // fontSize: 12,

            fontWeight: "bold",
        },
    },
    namesTypo: {
        paddingLeft: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: 0,
        display: "flex",
        flexDirection: "row",

        names: {
            fontSize: 12,
            completed: {
                fontWeight: "bold",
                fontSize: 12,
            },
        },

        scoreOutStyle: {
            display: "flex",
            flexDirection: "row",

            score: {
                fontSize: 12,
                marginLeft: 5,

                completed: {
                    fontSize: 12,
                    marginLeft: 4,
                    display: "inline-block",
                    width: "20px",
                    textAlign: "right",
                },
            },
            scoreLive: {
                fontSize: 12,
                marginLeft: 5,
                backgroundColor: "#04bd19",
                color: "white",
                width: "auto",
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
                padding: "2px 2px 2px 2px",
            },
        },
    },
    venueStyle: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",

        venueFontSize: {
            fontSize: 9,
        },
    },
    divider: {
        borderTop: "1px solid #bbb",
    },
    completed: {
        backgroundColor: "red",
        height: "1px",
        border: 0,
    },
    playIcon: {
        color: "#04bd19",
    },
    supTiebreak: {
        display: "inline-block",
        width: "0.5em",
        textAlign: "left"
    }
} as const;
